export const toQueryParams = (
  query: Record<string, any>,
  filter = (_value: any) => true
) => {
  try {
    const queryKeys = Object.keys({ ...query }).filter((k) =>
      filter(query?.[k])
    )

    if (!queryKeys.length) return undefined

    const params = new URLSearchParams()

    queryKeys.forEach((k) => {
      const value = query[k]

      if (Array.isArray(value)) {
        value?.forEach((item) => {
          params.append(k, item)
        })
      } else if (k !== 'polygon') {
        params.append(k, value)
      }
    })

    return `?${params.toString()}`
  } catch (error) {
    console.error(error)

    return undefined
  }
}

export type ID = string | number

export const arrayFy = (value: ID | ID[]) => {
  return Array.isArray(value) ? value : [value].filter((n) => n != null)
}

export const isValidHttpUrl = (str: string) => {
  let url

  try {
    url = new URL(str)
  } catch {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}

// query param

export const fromArrayFilter = (filter: string) => {
  return filter?.split(',').map(decodeURIComponent)
}

export const toFilter = (filter: string[] | { min: string; max: string }) => {
  if (Array.isArray(filter)) {
    return filter.map(encodeURIComponent).join(',')
  }

  const { min, max } = filter || {}

  if (!min && !max) return undefined

  return [min, max].map(encodeURIComponent).join(',')
}

export const fromFilter = (filter: string | string[], range?: boolean) => {
  if (Array.isArray(filter)) return filter

  if (!range) return fromArrayFilter(filter)

  const [min, max] = fromArrayFilter(filter) || []

  if (!min && !max) return undefined

  return { min, max }
}

export const getRangeFilterText = (range: any, title = '') => {
  const rangeFilter =
    typeof range === 'string'
      ? range
      : [range?.[0] ?? range?.min, range?.[1] ?? range?.max]

  const values = Array.isArray(rangeFilter)
    ? rangeFilter
    : fromArrayFilter(rangeFilter)

  if (!values[0] && !values[1]) return undefined

  if (values[0] === '0' && values[1] === '0') return undefined

  const text = values?.length
    ? `${values[0] || '0'} - ${values[1] || '∞'}`
    : undefined

  if (!title) return text

  return text ? `${title}: ${text}` : undefined
}

export const getArrayFilterText = (range: any, title = '') => {
  const values = Array.isArray(range) ? range : fromArrayFilter(range)

  const text = values?.join(', ')

  if (!title) return text

  return text ? `${title}: ${text}` : undefined
}
